<template>
  <div>
    <div v-if="loading">
      <pickstar-loading/>
    </div>
    <div v-else>
      <div class="dashboard-page-title">
        Tree
        <system-tag-tree-item @refreshTree="getTree" @editing="() => { this.loading = true }" v-for="item in tree" :key="item.id" :item="item"/>
      </div>
      <div>
        Uncategorized Tags - {{ pagination.total ? 'Showing ' + (tags ? tags.length : 0) + '/' + pagination.total : '' }}
        <div class="flex flex-row">
          <input placeholder="Search..." class="form-control" type="text" v-model="search" @keypress.enter="getUncategorizedTags"/>
          <selectize
            @input="getUncategorizedTags"
            placeholder="Type"
            class="selectize selectize-single form-control"
            name="tag_type"
            :options="tagTypeOptions"
            v-model="type"
            :disable-delete="true">
          </selectize>
          <ladda-button class="button btn-primary" :click="getUncategorizedTags">Search</ladda-button>
        </div>
        <system-tag-tree-item @refreshTree="getTree" @editing="() => { this.loading = true }" v-for="item in tags" :key="item.id" :item="item"/>
        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="getNextUncategorizedTags"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'
import SystemTagTreeItem from './SystemTagTreeItem'
import Selectize from '../ext/codium/CodiumSelectize'
import LazyLoading from 'codium-lazy-loading'
export default {
  components: {SystemTagTreeItem, Selectize, LazyLoading},
  data () {
    return {
      tree: [],
      tags: [],
      loading: true,
      search: '',
      type: null,
      pagination: {}
    }
  },

  computed: {
    tagTypeOptions () {
      const options = [
        { id: 'sport', text: this.$isNrlClient ? 'Category' : 'Sport' },
        { id: 'league', text: 'League' },
        { id: 'club', text: this.$isNrlClub ? 'Squad/Group' : 'Club' },
        { id: 'sponsor', text: 'Sponsor' },
        { id: 'charity', text: 'Charity' },
        { id: 'theme', text: 'Theme' },
        { id: 'description', text: 'Description' },
        { id: 'industry', text: 'Industry' }
      ]
      if (this.clientName === 'GSE') {
        options.push({ id: 'position', text: 'Position' })
      }
      return options
    }
  },

  methods: {
    getTree () {
      this.loading = true
      setTimeout(() => {
        http.get('tree-management').then(response => {
          this.tree = response.data
          this.loading = false
        })
        this.getUncategorizedTags()
      }, 500)
    },

    getUncategorizedTags () {
      return http.get('uncategorized-tags', { params: { search: this.search, type: this.type } }).then(response => {
        this.tags = response.data.data
        this.pagination = response.data.meta
        this.loading = false
      })
    },

    getNextUncategorizedTags () {
      if (this.pagination && this.pagination.current_page < this.pagination.last_page) {
        return http.get('uncategorized-tags', { params: { search: this.search, type: this.type, page: this.pagination.current_page + 1 } }).then(response => {
          this.tags.push(...response.data.data)
          this.pagination = response.data.meta
          this.loading = false
        })
      }
      return Promise.resolve()
    }
  },

  mounted () {
    this.getTree()
  }
}
</script>
